import { Button, Flex } from "@/atoms"
import { Form } from "@/organisms/Form"

// Cancel/Save for the policy form inside the drawer; Save submits the form the
// page context holds, so the form's own onFinish does the saving.
export const DrawerFormFooter = (props: { onCancel: () => void }) => {
  const { form } = Form.useForm()

  return (
    <Flex align="center" justify="flex-end" gap={10}>
      <Button onClick={props.onCancel}>Cancel</Button>
      <Button type="primary" onClick={() => form.submit()}>
        Save
      </Button>
    </Flex>
  )
}
